import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/solutions', label: 'Solutions' },
    { path: '/cinema-design', label: 'Home Cinema Design' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/brands', label: 'Our Brands' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-zinc-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_mjaudiovision/artifacts/3t1khq80_MJ%20audio%20%281%29%20-%20Copy.png" 
              alt="MJ Audio Logo"
              className="h-16 sm:h-18 w-auto transform group-hover:scale-105 transition-transform duration-300"
              style={{ imageRendering: '-webkit-optimize-contrast', filter: 'brightness(1.1)' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`relative px-5 py-2.5 text-sm font-medium rounded-full transition-all duration-300 ${
                    isActive 
                      ? 'text-green-500 bg-green-600/15' 
                      : 'text-gray-300 hover:text-green-400 hover:bg-zinc-800'
                  }`}
                  onMouseEnter={(e) => {
                    if (!isActive) e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <a href="tel:+914623593978">
              <Button className="bg-green-600 hover:bg-green-700 text-white transition-all duration-300 hover:scale-105 rounded-full px-6">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black border-t border-zinc-800">
          <nav className="container mx-auto px-4 py-6 flex flex-col space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-base font-medium py-3 px-5 rounded-full transition-all duration-300 ${
                  location.pathname === link.path 
                    ? 'text-green-500 bg-green-600/10' 
                    : 'text-gray-300 hover:text-green-400 hover:bg-zinc-800'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a href="tel:+914623593978" className="pt-2">
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white rounded-full">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
